import { motion } from "framer-motion";
import { Check } from "lucide-react";

const ABOUT_IMG =
  "https://images.pexels.com/photos/7691101/pexels-photo-7691101.jpeg?auto=compress&cs=tinysrgb&w=1200";

const points = [
  "A dedicated, background-checked cleaner you know by name",
  "Eco-friendly products that are safe for children and pets",
  "Flexible scheduling that fits around your life and business",
  "Fully insured work with a 100% satisfaction promise",
];

const stats = [
  { value: "500+", label: "Spaces transformed" },
  { value: "5.0", label: "Average rating" },
  { value: "100%", label: "Insured & vetted" },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2 lg:gap-20 lg:px-12">
      <motion.div
        initial={{ opacity: 0, x: -32 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div className="absolute -left-4 -top-4 h-full w-full rounded-3xl border-2 border-teal-200" />
        <img
          src={ABOUT_IMG}
          alt="Crisp folded linens prepared by the Hyek team"
          loading="lazy"
          className="relative aspect-[4/5] w-full rounded-3xl object-cover shadow-xl"
        />
        <div className="absolute -bottom-6 -right-4 rounded-2xl bg-teal-700 px-6 py-5 shadow-lg sm:-right-6">
          <p className="font-serif text-3xl font-semibold text-white">5.0</p>
          <p className="text-xs font-bold uppercase tracking-[0.15em] text-teal-200">Rated by clients</p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-teal-700">About Us</p>
        <h2 className="font-serif text-4xl font-medium tracking-tight text-slate-900 sm:text-5xl">
          A team that treats your space <span className="italic text-teal-700">like our own.</span>
        </h2>
        <p className="mt-6 text-sm leading-relaxed text-slate-500 sm:text-base">
          Hyek Cleaning Services Ltd was founded on a simple belief: a clean space changes how you
          feel, work and live. What began as a small local team has grown into one of the most
          trusted cleaning services in the area — built entirely on word of mouth, reliability and
          an obsession with the details others miss.
        </p>
        <ul className="mt-8 flex flex-col gap-4">
          {points.map((p) => (
            <li key={p} className="flex items-start gap-3 text-sm font-semibold text-slate-700">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-100 text-teal-700">
                <Check className="h-3 w-3" />
              </span>
              {p}
            </li>
          ))}
        </ul>
        <div className="mt-12 grid grid-cols-3 gap-6 border-t border-slate-100 pt-10">
          {stats.map((s) => (
            <div key={s.label}>
              <p className="font-serif text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
                {s.value}
              </p>
              <p className="mt-1 text-xs font-bold uppercase tracking-[0.12em] text-slate-400">{s.label}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
